import { useState, ReactElement } from 'react';

interface Payload<TValue> {
    value: TValue[];
    isUploading: boolean;
    onUploadFiles: (files: File[]) => Promise<void>;
}

interface UploadProps<TValue> {
    value?: TValue[];
    onChange: (value: TValue[]) => void;
    onUploadFile: (file: File) => Promise<TValue | undefined>;
    children: (payload: Payload<TValue>) => ReactElement;
}

export function Upload<TValue>(props: UploadProps<TValue>) {
    const { children, value = [], onChange, onUploadFile } = props;
    const [isUploading, setIsUploading] = useState(false);
    const onUploadFiles = async (files: File[]) => {
        if (files.length === 0) {
            return;
        }

        setIsUploading(true);

        try {
            const responses = await Promise.all(
                files.map((file) => onUploadFile(file).catch(() => null)),
            );

            const uploadedFiles = responses.filter(Boolean) as TValue[];

            onChange([...value, ...uploadedFiles]);
        } catch (_error) {
            /* empty */
        }

        setIsUploading(false);
    };

    return children({ value, isUploading, onUploadFiles });
}
